import React from 'react';
import styled from 'styled-components';
import Icon, { CloseOutlined } from '@ant-design/icons';

import { colors } from 'helpers/ColorHelper';

const StyledContainer = styled.div`
  margin-bottom: 20px;
  margin-right: 20px;
  &:first-child {
    margin-left: 0px;
  }
  &:last-child {
    margin-right: 0px;
  }
`;

const StyledInput = styled.input`
  display: none;
`;

const StyledIcon = styled(Icon)`
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  font-size: 12px;
`;

const StyledLabel = styled.label`
  display: inline-block;
  color: ${(props) => (props.checked ? '#fff!important' : `${colors.DARK}!important`)};
  background-color: ${(props) => (props.checked ? props.accentColor : '#fff')};
  font-size: 10px;
  line-height: 32px;
  font-weight: bold;
  text-transform: uppercase;
  border: 1px solid ${(props) => (props.checked ? props.accentColor : colors.LIGHT_PERIWINKLE)};
  border-radius: 28px;
  padding-left: 20px;
  padding-right: ${(props) => (props.checked ? '35px' : '20px')};
  padding-top: 0;
  padding-bottom: 0;
  text-align: center;
  cursor: pointer;
  position: relative;
`;

const Checkbox = ({
  accentColor = colors.ULTRAMARINE_BLUE,
  value,
  name,
  children,
  handleChange,
  style,
  ...rest
}) => {
  return (
    <StyledContainer style={style}>
      <StyledInput
        type="checkbox"
        id={name}
        name={name}
        value={value}
        checked={value}
        onChange={handleChange}
      />
      <StyledLabel htmlFor={name} accentColor={accentColor} checked={value} {...rest}>
        {children}
        {value && <StyledIcon component={CloseOutlined} />}
      </StyledLabel>
    </StyledContainer>
  );
};

export default Checkbox;
